import { postData } from "../common/Apicall";

export const getReviewByProductApi = (productID) => {
  return postData("/api/v1/reviews/getReview", { productID });
};

export const getStoreProductReviewApi = (storeID, page) => {
  return postData(`/api/v1/reviews/storeProductReviews?page=${page}`, {
    storeID,
    page,
  });
};

export const createReviewApi = (userID, productID, content, rating) => {
  return postData(`/api/v1/reviews/toAddReview`, {
    userID,
    productID,
    content,
    rating,
  });
};
